/* eslint-disable */
import { INestedQuestionSet } from 'Models/BOB/ResponseModels/Life/QuestionSet'

// const fatcaFormObject: { form_fields: INestedQuestionSet[] } = {
//   form_fields: [
//     {
//       max: undefined,
//       name: 'Are you born in India?',
//       code: 'isBornInIndia',
//       dropdown: {
//         True: 'Yes',
//         False: 'No',
//       },
//       cover_type: 'switch',
//       min: undefined,
//       description: 'Choose One of ',
//       input_type: 'Boolean',
//       hidden: false,
//       values: {
//         True: [],
//         False: [
//           {
//             max: undefined,
//             name: 'Country of Birth?',
//             code: 'placeOfBirthCountry',
//             dropdown: undefined,
//             cover_type: 'dropdown',
//             min: undefined,
//             description: 'Please Enter Country of Birth',
//             input_type: 'String',
//             hidden: false,
//             values: {},
//           },
//         ],
//       },
//     },
//     {
//       max: undefined,
//       name: 'Place of Birth',
//       code: 'placeOfBirthCity',
//       dropdown: undefined,
//       cover_type: 'Text',
//       min: undefined,
//       description: 'Please Enter Place of Birth',
//       input_type: 'String',
//       hidden: false,
//       range: false,
//       values: {},
//     },
//     {
//       max: undefined,
//       name: "Father's name",
//       code: 'fatherName',
//       dropdown: undefined,
//       cover_type: 'Text',
//       min: undefined,
//       description: 'Please Enter Fathers name',
//       input_type: 'String',
//       hidden: false,
//       range: false,
//       values: {},
//     },
//     {
//       max: undefined,
//       name: 'Are you a Citizen of another Country?',
//       code: 'isCitizenOfOtherCountry',
//       dropdown: {
//         True: 'Yes',
//         False: 'No',
//       },
//       cover_type: 'switch',
//       min: undefined,
//       description: 'Choose One of ',
//       input_type: 'Boolean',
//       hidden: false,
//       values: {
//         True: [
//           {
//             max: undefined,
//             name: 'Are you a citizen of US?',
//             code: 'isGreenCardHolderOfUS',
//             dropdown: {
//               True: 'Yes',
//               False: 'No',
//             },
//             cover_type: 'switch',
//             min: undefined,
//             description: 'Choose One of ',
//             input_type: 'Boolean',
//             hidden: false,
//             values: {
//               True: [],
//               False: [
//                 {
//                   max: undefined,
//                   name: 'Country of citizenship?',
//                   code: 'countryOfCitizenship',
//                   dropdown: {},
//                   cover_type: 'dropdown',
//                   min: undefined,
//                   description: 'Please enter Country of citizenship',
//                   input_type: 'String',
//                   hidden: false,
//                   values: {},
//                 },
//               ],
//             },
//           },
//         ],
//         False: [],
//       },
//     },
//     {
//       max: undefined,
//       name: 'Are you a resident of another country?',
//       code: 'isResidentOfOtherCountry',
//       dropdown: {
//         True: 'Yes',
//         False: 'No',
//       },
//       cover_type: 'switch',
//       min: undefined,
//       description: 'Choose One of ',
//       input_type: 'Boolean',
//       hidden: false,
//       values: {
//         True: [
//           {
//             max: undefined,
//             name: 'Are you a Green Card Holder of US?',
//             code: 'isGreenCardHolderOfUS',
//             dropdown: {
//               True: 'Yes',
//               False: 'No',
//             },
//             cover_type: 'switch',
//             min: undefined,
//             description: 'Choose One of ',
//             input_type: 'Boolean',
//             hidden: false,
//             values: {
//               True: [],
//               False: [
//                 {
//                   max: undefined,
//                   name: 'Are you a Resident of Country other than US?',
//                   code: 'isResidentOfOtherCountryThanUS',
//                   dropdown: {
//                     True: 'Yes',
//                     False: 'No',
//                   },
//                   cover_type: 'switch',
//                   min: undefined,
//                   description: 'Choose One of ',
//                   input_type: 'Boolean',
//                   hidden: false,
//                   values: {},
//                 },
//                 {
//                   max: undefined,
//                   name: 'Country of Residency?',
//                   code: 'countryOfResidency',
//                   dropdown: {},
//                   cover_type: 'dropdown',
//                   min: undefined,
//                   description: 'Please Select Country of Residency?',
//                   input_type: 'String',
//                   hidden: false,
//                   values: {},
//                 },
//               ],
//             },
//           },
//           {
//             max: undefined,
//             name: 'Are you a Tax Resident of any country except India?',
//             code: 'isTaxPurposeCountryOutsideIndia',
//             dropdown: {
//               True: 'Yes',
//               False: 'No',
//             },
//             cover_type: 'switch',
//             min: undefined,
//             description: 'Choose One of ',
//             input_type: 'Boolean',
//             hidden: false,
//             values: {
//               True: [
//                 {
//                   max: undefined,
//                   name: 'Country of Tax Residency?',
//                   code: 'countryOfResidencyOfTaxPurpose',
//                   dropdown: {},
//                   cover_type: 'dropdown',
//                   min: undefined,
//                   description: 'Please Select Country of Tax Residency?',
//                   input_type: 'String',
//                   hidden: false,
//                   values: {},
//                 },
//               ],
//               False: [],
//             },
//           },
//           {
//             max: undefined,
//             name: 'Tax Identification Number (TIN)',
//             code: 'tinNumber',
//             dropdown: undefined,
//             cover_type: 'Text',
//             min: undefined,
//             description: 'Please Enter Tax Identification Number (TIN)',
//             input_type: 'String',
//             hidden: false,
//             values: {},
//           },
//           {
//             max: undefined,
//             name: 'Country of Issuing “Identity Proof”',
//             code: 'countryIssuingIdProof',
//             dropdown: {},
//             cover_type: 'Text',
//             min: undefined,
//             description: 'Please Enter Country of Issuing “Identity Proof”',
//             input_type: 'String',
//             hidden: false,
//             values: {},
//           },
//           {
//             max: undefined,
//             name: 'Telephone number outside of India?',
//             code: 'isTelephoneOutsideIndia',
//             dropdown: {
//               True: 'Yes',
//               False: 'No',
//             },
//             cover_type: 'switch',
//             min: undefined,
//             description: 'Choose One of ',
//             input_type: 'Boolean',
//             hidden: false,
//             values: {
//               True: [
//                 {
//                   max: undefined,
//                   name: 'Telephone Number',
//                   code: 'telephoneOutsideIndiaDetails',
//                   dropdown: undefined,
//                   cover_type: 'Text',
//                   min: undefined,
//                   description: 'Please Enter Telephone Number',
//                   input_type: 'String',
//                   hidden: false,
//                   values: {},
//                 },
//               ],
//               False: [],
//             },
//           },
//           {
//             max: undefined,
//             name: 'Do you possess power of attorney outside of India?',
//             code: 'isHavingPowerOfAttorneyOutsideIndia',
//             dropdown: {
//               True: 'Yes',
//               False: 'No',
//             },
//             cover_type: 'switch',
//             min: undefined,
//             description: 'Choose One of ',
//             input_type: 'Boolean',
//             hidden: false,
//             values: {
//               True: [
//                 {
//                   max: undefined,
//                   name: 'Source of Income',
//                   code: 'incomeSource',
//                   dropdown: undefined,
//                   cover_type: 'Text',
//                   min: undefined,
//                   description: 'Please Enter Source of Income',
//                   input_type: 'String',
//                   hidden: false,
//                   values: {},
//                 },
//               ],
//               False: [],
//             },
//           },
//           {
//             max: undefined,
//             name: 'Does the Permanent Address extend outside of India?',
//             code: 'isPermanentAddressOutsideIndia',
//             dropdown: {
//               True: 'Yes',
//               False: 'No',
//             },
//             cover_type: 'switch',
//             min: undefined,
//             description: 'Choose One of ',
//             input_type: 'Boolean',
//             hidden: false,
//             values: {
//               True: [
//                 {
//                   max: undefined,
//                   name: 'Address',
//                   code: 'addressOutsideIndia',
//                   dropdown: undefined,
//                   cover_type: 'Text',
//                   min: undefined,
//                   description: 'Please Enter Address',
//                   input_type: 'String',
//                   hidden: false,
//                   values: {},
//                 },
//               ],
//               False: [],
//             },
//           },
//         ],
//         False: [],
//       },
//     },
//   ],
// }

const fatcaFormObject: { form_fields: INestedQuestionSet[] } = {
  form_fields: [
    {
      max: undefined,
      name: 'Are you Born in India?',
      code: 'isBornInIndia',
      dropdown: {
        True: 'True',
        False: 'False',
      },
      cover_type: 'switch',
      min: undefined,
      description: '',
      input_type: 'Boolean',
      hidden: false,
      values: {
        True: [
          // {
          //   max: undefined,
          //   name: 'Country of Birth?',
          //   code: 'placeOfBirthCountry',
          //   dropdown: undefined,
          //   cover_type: 'dropdown',
          //   min: undefined,
          //   description: 'Please Enter Country of Birth',
          //   input_type: 'String',
          //   hidden: false,
          //   default: 'India',
          //   values: {},
          // },
        ],
        False: [
          {
            max: undefined,
            name: 'Country of Birth?',
            code: 'placeOfBirthCountry',
            dropdown: undefined,
            cover_type: 'dropdown',
            min: undefined,
            description: '',
            input_type: 'String',
            hidden: false,
            // default: 'India',
            values: {},
          },
        ],
      },
    },
    {
      max: undefined,
      name: 'Place of Birth',
      code: 'placeOfBirthCity',
      dropdown: undefined,
      cover_type: 'Text',
      regex: /^[A-Za-z][A-Za-z ]*$/,
      min: undefined,
      description: '',
      input_type: 'String',
      hidden: false,
      range: false,
      values: {},
    },
    {
      max: undefined,
      name: "Father's name",
      code: 'fatherName',
      dropdown: undefined,
      regex: /^[A-Za-z][A-Za-z ]*$/,
      cover_type: 'Text',
      min: undefined,
      description: '',
      input_type: 'String',
      hidden: false,
      range: false,
      values: {},
    },
    {
      max: undefined,
      name: 'Are you citizen of any other country other than India?',
      code: 'isCitizenOfOtherCountry',
      dropdown: {
        True: 'True',
        False: 'False',
      },
      cover_type: 'switch',
      min: undefined,
      description: '',
      input_type: 'Boolean',
      hidden: false,
      values: {
        True: [
          // {
          //   max: 35,
          //   min: 3,
          //   name: 'Source Of Income',
          //   code: 'incomeSource',
          //   dropdown: undefined,
          //   cover_type: 'Text',
          //   description: 'Please Enter Source Of Income',
          //   input_type: 'String',
          //   hidden: false,
          //   range: false,
          //   values: {},
          // },
        ],
        False: [],
      },
    },
    {
      max: undefined,
      name: 'Are you resident (for tax purpose) of any other country other than India?',
      code: 'isResidentOfOtherCountry',
      dropdown: {
        True: 'True',
        False: 'False',
      },
      cover_type: 'switch',
      min: undefined,
      description: '',
      input_type: 'Boolean',
      hidden: false,
      values: {
        True: [
          {
            max: undefined,
            name: 'Tax Identification Number (TIN)',
            code: 'tinNumber',
            regex: /^[A-Za-z0-9\-]{1,20}$/,
            dropdown: undefined,
            cover_type: 'Text',
            min: undefined,
            description: '',
            input_type: 'String',
            hidden: false,
            values: {},
          },
          {
            // dropdown of country
            max: undefined,
            name: 'Country of Issuing “Identity Proof”',
            code: 'countryIssuingIdProof',
            dropdown: {
              // India: 'India',
            },
            cover_type: 'dropdown',
            min: undefined,
            description: '',
            input_type: 'String',
            hidden: false,
            values: {},
          },
          {
            max: undefined,
            name: 'Do You Have A Country Of Residence For Tax Purpose Outside India?',
            code: 'isTaxPurposeCountryOutsideIndia',
            dropdown: {
              True: 'True',
              False: 'False',
            },
            cover_type: 'switch',
            min: undefined,
            description: '',
            input_type: 'Boolean',
            hidden: false,
            values: {
              True: [
                {
                  max: undefined,
                  name: 'Country Of Residence for Tax Purpose',
                  code: 'countryOfResidencyOfTaxPurpose',
                  dropdown: {},
                  cover_type: 'dropdown',
                  min: undefined,
                  description: '',
                  input_type: 'String',
                  hidden: false,
                  values: {},
                },
              ],
              False: [],
            },
          },
          // {
          //   max: 35,
          //   min: 3,
          //   name: 'Source Of Income',
          //   code: 'incomeSource',
          //   dropdown: undefined,
          //   cover_type: 'Text',
          //   description: 'Please Enter Source Of Income',
          //   input_type: 'String',
          //   hidden: false,
          //   range: false,
          //   values: {},
          // },
        ],
        False: [],
      },
    },
    {
      max: undefined,
      name: 'Do you Hold green card of US or any similar document for any other Country?',
      code: 'isGreenCardHolderOfUS',
      dropdown: {
        True: 'True',
        False: 'False',
      },
      cover_type: 'switch',
      min: undefined,
      description: '',
      input_type: 'Boolean',
      hidden: false,
      values: {
        True: [
          {
            max: undefined,
            name: 'Are you US resident?',
            code: 'isAUSResident',
            dropdown: {
              True: 'True',
              False: 'False',
            },
            cover_type: 'switch',
            min: undefined,
            description: '',
            input_type: 'Boolean',
            hidden: false,
            values: {
              True: [],
              False: [
                {
                  max: undefined,
                  name: 'Are You Resident Of Any Other Country Other Than US?',
                  code: 'isResidentOfOtherCountryThanUS',
                  dropdown: {
                    True: 'True',
                    False: 'False',
                  },
                  cover_type: 'switch',
                  min: undefined,
                  description: '',
                  input_type: 'Boolean',
                  hidden: false,
                  values: {
                    True: [
                      {
                        // dropdown of country
                        max: undefined,
                        name: 'Country Of Residence',
                        code: 'countryOfResidency',
                        dropdown: undefined,
                        cover_type: 'dropdown',
                        min: undefined,
                        description: '',
                        input_type: 'String',
                        hidden: false,
                        values: {},
                      },
                      {
                        // dropdown of country
                        max: undefined,
                        name: 'Country Of Citizenship',
                        code: 'countryOfCitizenship',
                        dropdown: undefined,
                        cover_type: 'dropdown',
                        min: undefined,
                        description: '',
                        input_type: 'String',
                        hidden: false,
                        values: {},
                      },
                    ],
                    False: [],
                  },
                },
              ],
            },
          },
          {
            max: 35,
            min: 3,
            name: 'Source Of Income',
            code: 'incomeSource',
            dropdown: undefined,
            cover_type: 'Text',
            description: '',
            input_type: 'String',
            hidden: false,
            range: false,
            values: {},
          },
        ],
        False: [],
      },
    },
    {
      max: undefined,
      name: 'Telephone number outside of India?',
      code: 'isTelephoneOutsideIndia',
      dropdown: {
        True: 'True',
        False: 'False',
      },
      cover_type: 'switch',
      min: undefined,
      description: '',
      input_type: 'Boolean',
      hidden: false,
      values: {
        True: [
          {
            max: undefined,
            name: 'Telephone Number(With Country Code)',
            code: 'telephoneOutsideIndiaDetails',
            regex: /^[0-9]{10,12}$/,
            dropdown: undefined,
            cover_type: 'Text',
            min: undefined,
            description: '',
            input_type: 'String',
            hidden: false,
            values: {},
          },
        ],
        False: [],
      },
    },
    {
      max: undefined,
      name: 'Do you have communication Permanent Address outside India?',
      code: 'isPermanentAddressOutsideIndia',
      dropdown: {
        True: 'True',
        False: 'False',
      },
      cover_type: 'switch',
      min: undefined,
      description: '',
      input_type: 'Boolean',
      hidden: false,
      values: {
        True: [
          {
            max: undefined,
            name: 'Address Outside India',
            code: 'addressOutsideIndia',
            dropdown: undefined,
            cover_type: 'Text',
            min: undefined,
            description: '',
            input_type: 'String',
            hidden: false,
            values: {},
          },
        ],
        False: [],
      },
    },
    {
      max: undefined,
      name: 'Do you possess power of attorney outside of India?',
      code: 'isHavingPowerOfAttorneyOutsideIndia',
      dropdown: {
        True: 'True',
        False: 'False',
      },
      cover_type: 'switch',
      min: undefined,
      description: '',
      input_type: 'Boolean',
      hidden: false,
      values: {},
    },
  ],
}

export { fatcaFormObject }
